function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M25.007,6.093c-2.695,0-4.974-1.444-5.732-2.056c-0.171,0.651-0.268,1.339-0.268,2.056c0,3.866,2.686,7,6,7s6-3.134,6-7c0-0.716-0.097-1.405-0.268-2.056C29.981,4.649,27.702,6.093,25.007,6.093z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.707,20.66C38.355,18.263,37,14.594,37,10.593V5c0-0.483-0.339-0.897-0.814-0.984l-4.898-0.888L31.146,3.07c-0.345-0.136-0.745-0.063-1.026,0.177l-0.129,0.101c-0.427,0.337-0.487,0.941-0.158,1.375c0.016,0.021,0.033,0.042,0.05,0.061c0.083,0.434,0.124,0.873,0.124,1.309c0,3.309-2.243,6-5,6s-5-2.691-5-6c0-0.423,0.039-0.847,0.116-1.267c0.023-0.025,0.047-0.051,0.068-0.079c0.336-0.431,0.264-1.052-0.163-1.394c-0.003-0.003-0.129-0.102-0.132-0.105c-0.283-0.248-0.679-0.317-1.025-0.179l-5.043,0.947c-0.476,0.086-0.821,0.5-0.821,0.984v5.593c0,3.95-1.388,7.718-3.713,10.08c-0.184,0.187-0.287,0.439-0.287,0.702V46c0,0.553,0.447,1,1,1h29.986c0.553,0,1-0.447,1-1V21.36C40.993,21.099,40.891,20.847,40.707,20.66z M24,27l-5,3v1h5v2h-7v-4l5-3v-3h-3v1h-2v-2l1-1h5l1,1V27z M33,26l-1,1l1,1v4l-1,1h-5l-1-1v-2h2v1h3v-3h-2v-2h2v-3h-3v1h-2v-2l1-1h5l1,1V26z"
});

function SvgSportsJersey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsJersey);
export default __webpack_public_path__ + "static/media/sports-jersey.9c005e07.svg";
export { ForwardRef as ReactComponent };